module.exports = __webpack_public_path__ + "img/rocarbon5.bfb58a14.png";